<template>
    <button class="nav-bar-button" :class="{ active: active, red: isRed }" @click="clickInButton">
        <div class="nav-bar-button__icon-wrap">
            <simple-svg v-if="icon" :src="icon" :custom-class-name="isRed ? 'icon-red' : 'icon'" />
            <span v-if="badge > 0" class="nav-bar-button__badge">{{ badge > 99 ? '99+' : badge }}</span>
        </div>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'NavBarButton',

    props: {
        text: {
            type: String,
        },
        icon: {
            type: String,
        },
        path: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false
        },
        isRed: {
            type: Boolean,
            default: false
        },
        badge: {
            type: Number,
            default: 0
        },
    },

    methods: {
        clickInButton() {
            if (this.path) {
                this.$router.push(this.path)
            }
        }
    }
}
</script>

<style lang="scss">
.nav-bar-button {
    box-sizing: border-box;

    background-color: var(--color-bg);
    border: none;
    border-radius: 5px;
    padding: 5px;
    width: 100%;

    color: var(--color-text);
    text-align: start;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;

    display: flex;
    align-items: center;
    gap: 10px;

    &__icon-wrap {
        position: relative;
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    &__badge {
        position: absolute;
        top: -5px;
        right: -6px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        background: var(--color-blue);
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        box-sizing: border-box;
    }

    .icon {
        width: 20px;
        height: 20px;

        path {
            stroke: var(--color-text);
        }

    }

    &.red {
        color: var(--color-red);

        &:hover {
            background-color: color-mix(in srgb, var(--color-red) 10%, transparent);
        }
    }

    &.active {
        position: relative;
        //border-radius: 0 5px 5px 0;

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 3px;
            height: 100%;
            border-radius: 1.5px;
            background-color: var(--color-blue);
        }

        //background-color: var(--color-blue);
    }

    &:hover {
        overflow: hidden;
        background-color: color-mix(in srgb, var(--color-bg-light) 50%, transparent);
    }

    &:active {
        background-color: var(--color-bg-light);
        color: var(--color-text-dark);
    }
}
</style>
